import React, { useState } from "react";
import { ToolbarContainer } from "./StyledToolbar";
import { IconButton, Divider } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchIcon from "@mui/icons-material/Search";
import RefreshIcon from "@mui/icons-material/Refresh";
import RestoreIcon from '@mui/icons-material/Restore';
import Tooltip from "@mui/material/Tooltip";
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ClearIcon from "@mui/icons-material/Clear";
import UndoIcon from "@mui/icons-material/Undo";
import FormGroup from '@mui/material/FormGroup';
import UploadFileIcon from "@mui/icons-material/UploadFile";
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';

import CompressIcon from '@mui/icons-material/Compress';
import ExpandIcon from '@mui/icons-material/Expand';

import MetaDataIcon from "../../../assets/icons/metadata.svg";
import TaxonomyIcon from "../../../assets/icons/taxonomy.svg";
import { PRIMARY_COLOR } from "../../../components/Common/StyleElement";
import { SearchFilter, DropdownMenu } from "../../../components/Form";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import * as SvgToPng from 'save-svg-as-png'
import * as d3 from "d3";
import cloneDeep from 'lodash/cloneDeep';

import AntSwitch from "../../../components/Form/AntSwitch";
import MuiSwitch from "../../../components/Form/MuiSwitch";

import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import FilterCenterFocusIcon from '@mui/icons-material/FilterCenterFocus';
import ImageIcon from '@mui/icons-material/Image';

import { jsPDF } from 'jspdf'
// import 'svg2pdf.js'

import { Canvg } from 'canvg';
import {DataUsageRounded} from "@mui/icons-material";

import downloadSvg from 'svg-crowbar';
import axios from "axios";
import {CSV_EXPORT, TRACK_API, SERVER_URL} from "../../../services/Config";
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import useWindowSize from "../Tracks/Service/useWindowSize";


const Toolbar = ({
    metaData,
    meta,
    filterGene,
    handleSearch,
    taxonomyLevel,
    taxonomy,
    handleTaxonomy,
    handleMeta,
    token,
    recordType,
    relocate,
    switchMode,
    zoom,
    changeWidth,
    trackLength,
    scale
}) => {
    const [showSearch, setShowSearch] = useState('false');
    const [showTaxonomy, setShowTaxonomy] = useState('false');
    const [showMeta, setShowMeta] = useState('true');

    const [showExport,setShowExport] = useState('false')

    const [width, height] = useWindowSize();

    const exportOption = [
        { value: "Null", name: "Choose export options:" },
        // { value: "PNG", name: "PNG" },
        // { value: "PDF", name: "PDF" },
        { value: "SVG", name: "SVG" },
    ];

    const handleRefresh = () => {
        window.location.reload(false);
    };

    const handleShowSearch = () => {
        setShowSearch((!(showSearch ==='true')).toString());
    };

    const handleShowTaxonomy = () => {
        setShowTaxonomy((!(showTaxonomy ==='true')).toString());
    };

    const handleShowMeta = () => {

        // setShowMeta(!showMeta);
        setShowMeta((!(showMeta ==='true')).toString());

    };

    const handleShowExport = () => {
        setShowExport((!(showExport ==='true')).toString());
    };

    const metaDataToolbarFilter = (meta) =>{
        // console.log(recordType)

        var result_meta = void 0
        var deleteMeta = void 0
        if(recordType === 'annotree_search' ){
            // deleteMeta = ['Product','Protein ID','Gene','ID'];
            deleteMeta = ['Protein ID','ID'];
            result_meta = meta.filter((m)=>{
                if(deleteMeta.indexOf(m['name']) > -1 ){
                    // console.log(m)
                    return false
                }
                return true
            })
        }
        else{
            deleteMeta = ['ID','Protein ID'];
            result_meta = meta.filter((m)=>{
                if(deleteMeta.indexOf(m['name']) > -1 ){
                    // console.log(m)
                    return false
                }
                return true
            })
        }

        // console.log(result_meta)
        return result_meta

        // var deleteMeta = ['Product','Protein ID','Gene'];
        // return meta.filter((m)=>{
        //     if(deleteMeta.indexOf(m['name']) > -1 ){
        //         // console.log(m)
        //         return false
        //     }
        //     return true
        // })
    }


    const handleExportPDF = (curOption) => {

        alert("Warning: Full image has been exported. Cannot crop to just this window.")
        // console.log(document.getElementById('chartPlot'))
        // SvgToPng.saveSvgAsPng(document.getElementById('chartPlot'), "plot.png");
        // console.log(curOption)
        // const canvas = document.getElementById(`chartPlot`);
        const canvas = document.getElementById(`plot`);
        //canvas.style.backgroundColor = `transparent`;
        canvas.style.backgroundColor = `white`;

        // const tmpcanvas = document.getElementById(`plot`);
        if(curOption === "PNG"){
            SvgToPng.saveSvgAsPng(canvas, `chartPlot.png`,{scale: 4});
        }
        else if (curOption === "PDF"){

            // SvgToPng.svgAsDataUri(canvas, {scale: 4},function(DataURI) {
            //     // Now we can use the fetchAPI to convert the dataURI into the correct format
            //     fetch(DataURI)
            //         .then((response) => {
            //             // console.log(response.url)
            //
            //         })
            //
            // });

            SvgToPng.svgAsPngUri(canvas, {scale: 4}, function(pngDataURI) {
                // Now we can use the fetchAPI to convert the dataURI into the correct format
                fetch(pngDataURI)
                    .then((response) => {
                        const CurUrl = response.url
                        var doc = new jsPDF( );

                        // add image
                        doc.addImage(CurUrl, 'PNG',5,5,150,150,"",'FAST');

                        // Save document
                        doc.save('chartPlot.pdf');
                        // return response.arrayBuffer();
                    })

            });
        }
        else if (curOption === "SVG"){

            // same calculation in tracks
            let scale_value = trackLength / scale;

            // create an array with elements from 0 to trackLength -1
            let orders = [...Array(trackLength).keys()]

            let y = d3
                .scaleBand()
                .domain(orders)
                .range([0, height * scale_value])
                .padding(0.1);

            // constant, same with the number in track.js
            let svgHeight = 768 -20

            // console.log('svg')
            // 0.5 is the default scale
            let actualHeight = 0.5 * (y.step() + height * scale_value)
            // console.log(actualHeight)
            // let curHeight = y.bandwidth() *trackLength * 0.8
            let curHeight = actualHeight

            // minimum height
            if(curHeight <= svgHeight){
                curHeight = svgHeight+ 100
            }

            // same formula in track.js
            let curWidth = (width - 75)

            // console.log(trackLength)

            // 200 comes from the initial trans in track.js
            // let tempYTrans = y.bandwidth() *trackLength * 0.7

            let tempYTrans = actualHeight + 50
            // let tempYTrans = y.bandwidth() *trackLength
            // if(tempYTrans <= svgHeight){
            //     tempYTrans = svgHeight+ 50
            // }
            let legendTrans = 'translate(200,'+ (tempYTrans).toString() +')'
            let scaleTrans = 'translate(200,'+ (tempYTrans + 30).toString() +')'

            //get svg element.
            // let svgChart = document.getElementById("chartPlot");
            let svgChart = document.getElementById("plot");
            let svgChartClone = svgChart.cloneNode(true)


            let svgLegend = document.getElementById("legendPlot");
            let svgLegendClone = svgLegend.cloneNode(true)

            let svgScale = document.getElementById("scaleBar");
            let svgScaleClone = svgScale.cloneNode(true)


            svgLegendClone.setAttribute('transform',legendTrans)
            svgScaleClone.setAttribute('transform',scaleTrans)
            // var tmpSvg = React.createElement('svg',{},[svg,svg1])
            let svgParent = document.createElement('svg')
            svgParent.setAttribute("height",curHeight.toString())
            svgParent.setAttribute("width",curWidth.toString())

            svgParent.appendChild(svgChartClone)
            svgParent.appendChild(svgLegendClone)
            svgParent.appendChild(svgScaleClone)

            // not sure if the following replacement useful XD
            svgChartClone.outerHTML = svgChartClone.outerHTML.replace(/svg/g,"g");
            svgLegendClone.outerHTML = svgLegendClone.outerHTML.replace(/svg/g,"g");
            svgScaleClone.outerHTML = svgScaleClone.outerHTML.replace(/svg/g,"g");

            // tmpSvg.appendChild(svg1)


            var serializer = new XMLSerializer();
            var source = serializer.serializeToString(svgParent);

            // console.log(source)

            if(source.match(/^<svg[^>]+"http\:\/\/www\.w3\.org\/1999\/xhtml"/)){
                source = source.replace(/^<svg[^>]+"http\:\/\/www\.w3\.org\/1999\/xhtml"/, '<svg');
            }
            if(!source.match(/^<svg[^>]+xmlns="http\:\/\/www\.w3\.org\/2000\/svg"/)){
                source = source.replace(/^<svg/, '<svg xmlns="http://www.w3.org/2000/svg"');
            }
            if(!source.match(/^<svg[^>]+"http\:\/\/www\.w3\.org\/1999\/xlink"/)){
                source = source.replace(/^<svg/, '<svg xmlns:xlink="http://www.w3.org/1999/xlink"');
            }


            // console.log(source)

            source = '<?xml version="1.0" standalone="no"?>\r\n' + source;

            var svgUrl = "data:image/svg+xml;charset=utf-8,"+encodeURIComponent(source);


            var downloadLink = document.createElement("a");
            downloadLink.href = svgUrl;
            downloadLink.download = "annoview.svg";
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);



            // downloadSvg(canvas);
        }
        else{
            // console.log("handle Export PDF error")
        }



    };


    const handleRelocate = () =>{
        relocate()
    }

    const handleSwitchMode = ()=>{
        switchMode()
    }

    const handleZoomIn = ()=>{
        zoom('ZoomIn')
    }

    const handleZoomOut = ()=>{
        zoom('ZoomOut')
    }



    const handleIncreaseWidth = ()=>{
        changeWidth('Increase')
    }

    const handleDecreaseWidth = ()=>{
        changeWidth('Decrease')
    }


    // function saveBlob(blob, filename) {
    //     // global.URL.createObjectURL = jest.fn();
    //     window.URL.createObjectURL = function() {};
    //     const url = URL.createObjectURL(blob);
    //     const a = document.createElement('a');
    //     a.href = url;
    //     a.download = filename;
    //     a.click();
    // }

    const handleDownloadCSV = () =>{
        const formData = new FormData();
        formData.append("token", token);
        axios
            .post(SERVER_URL + CSV_EXPORT, formData)
            .then(response=>{
                // console.log(response.data)

                var myblob = new Blob([response.data], {
                    type: 'text/plain'
                });
                const filename = "annoview.csv"
                const url = URL.createObjectURL(myblob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
                // saveBlob(myblob, 'annoview.csv');
            })
    }

    return (
        <ToolbarContainer>
            {/*<Tooltip title="Drag/Scroll" arrow disableInteractive>*/}
            {/*    <Typography>Off</Typography>*/}
            {/*    <AntSwitch defaultChecked inputProps={{ 'aria-label': 'ant design' }} />*/}
            {/*    <Typography>On</Typography>*/}
            {/*</Tooltip>*/}
            {/*<MuiSwitch sx={{ m: 1 }} defaultChecked size="small" onChange={handleSwitchMode} />*/}


            {/*<Stack direction="row" spacing={1} alignItems="center">*/}
            {/*    <Typography>Drag</Typography>*/}
            {/*    <AntSwitch defaultChecked inputProps={{ 'aria-label': 'ant design' }}*/}
            {/*               onChange={handleSwitchMode} />*/}
            {/*    <Typography>Scroll</Typography>*/}
            {/*</Stack>*/}

            <Tooltip title="Stretch" arrow disableInteractive>
                <IconButton aria-label="Stretch" onClick={handleIncreaseWidth}>
                    <ExpandIcon style={{ color: PRIMARY_COLOR }}
                                sx={ {transform: "rotate(90deg)"}}/>
                </IconButton>
            </Tooltip>

            <Tooltip title="Compress" arrow disableInteractive>
                <IconButton aria-label="Compress" onClick={handleDecreaseWidth}>
                    <CompressIcon style={{ color: PRIMARY_COLOR }}
                                  sx={ {transform: "rotate(90deg)"}}/>
                </IconButton>
            </Tooltip>

            <Tooltip title="Zoom In" arrow disableInteractive>
                <IconButton aria-label="Zoom In" onClick={handleZoomIn}>
                    <ZoomInIcon style={{ color: PRIMARY_COLOR }} />
                </IconButton>
            </Tooltip>

            <Tooltip title="Zoom Out" arrow disableInteractive>
                <IconButton aria-label="Zoom Out" onClick={handleZoomOut}>
                    <ZoomOutIcon style={{ color: PRIMARY_COLOR }} />
                </IconButton>
            </Tooltip>

            <Tooltip title="Reset" arrow disableInteractive>
                <IconButton aria-label="refresh" onClick={handleRefresh}>
                    <RefreshIcon style={{ color: PRIMARY_COLOR }} />
                </IconButton>
            </Tooltip>

            <Tooltip title="Recenter Image" arrow disableInteractive>
                <IconButton aria-label="relocate" onClick={handleRelocate}>
                    <FilterCenterFocusIcon style={{ color: PRIMARY_COLOR }} />
                </IconButton>
            </Tooltip>

            <Tooltip title="Download csv" arrow disableInteractive>
                <IconButton aria-label="download" onClick={handleDownloadCSV}>
                    <DownloadForOfflineIcon style={{ color: PRIMARY_COLOR }} />
                </IconButton>
            </Tooltip>

            <Tooltip title="Export image" arrow disableInteractive>
                <IconButton aria-label="export" onClick={handleShowExport}>
                    <ImageIcon style={{ color: PRIMARY_COLOR }} />
                </IconButton>
            </Tooltip>
            <DropdownMenu
                options={exportOption}
                display={showExport}
                val="value"
                label="name"
                value={"Null"}
                onChange={(event) => handleExportPDF(event.target.value)}
            />



            <Tooltip title="Search" arrow disableInteractive>
                <IconButton aria-label="search" onClick={handleShowSearch}>
                    <SearchIcon style={{ color: PRIMARY_COLOR }} />
                </IconButton>
            </Tooltip>
            <SearchFilter
                options={metaData.find((x) => x.value === meta).data}
                display={showSearch}
                placeholder="Search for a gene"
                inputValue={filterGene}
                onInputChange={(event, newInputValue) =>
                    handleSearch(newInputValue)
                }
            />
            <Tooltip title="Taxonomy Labels" arrow disableInteractive>
                <IconButton aria-label="taxonomy" onClick={handleShowTaxonomy}>
                    <img src={TaxonomyIcon} width={24} />
                </IconButton>
            </Tooltip>
            <DropdownMenu
                options={taxonomyLevel}
                display={showTaxonomy}
                val="value"
                label="name"
                value={taxonomy}
                onChange={(event) => handleTaxonomy(event.target.value)}
            />

            {/*<Divider orientation="vertical" variant="middle" flexItem />*/}
            {/*<Tooltip title="Delete" arrow disableInteractive>*/}
            {/*    <IconButton aria-label="delete">*/}
            {/*        <DeleteIcon style={{ color: PRIMARY_COLOR }} />*/}
            {/*    </IconButton>*/}
            {/*</Tooltip>*/}
            {/*<Tooltip title="Unselect All" arrow disableInteractive>*/}
            {/*    <IconButton aria-label="unselect">*/}
            {/*        <ClearIcon style={{ color: PRIMARY_COLOR }} />*/}
            {/*    </IconButton>*/}
            {/*</Tooltip>*/}
            {/*<Tooltip title="Undo Delete" arrow disableInteractive>*/}
            {/*    <IconButton aria-label="undo">*/}
            {/*        <UndoIcon style={{ color: PRIMARY_COLOR }} />*/}
            {/*    </IconButton>*/}
            {/*</Tooltip>*/}
            {/*<Divider orientation="vertical" variant="middle" flexItem />*/}
            {/*<Tooltip title="Add Metadata File" arrow disableInteractive>*/}
            {/*    <IconButton aria-label="add">*/}
            {/*        <UploadFileIcon style={{ color: PRIMARY_COLOR }} />*/}
            {/*    </IconButton>*/}
            {/*</Tooltip>*/}
            <Tooltip title="Change Displayed Metadata" arrow disableInteractive>
                {/*<IconButton aria-label="metadata" onClick={handleShowMeta}>*/}
                <IconButton aria-label="metadata" onClick={handleShowMeta}>
                    <img src={MetaDataIcon} width={24} />
                </IconButton>
            </Tooltip>
            <DropdownMenu
                options={metaDataToolbarFilter(metaData)}
                display={showMeta}
                val="value"
                label="name"
                value={meta}
                onChange={(event) => handleMeta(event.target.value)}
            />
        </ToolbarContainer>
    );
};

export default Toolbar;
